import React from 'react';
import PropTypes from 'prop-types';
import { validated } from 'react-custom-validation';

import { isRequired } from 'utils/validations';
import { handleTextChange } from 'utils/handle-changes';

import Button from 'components/Button';
import Form from 'components/Form';
import FormValidationMessage from 'components/FormValidationMessage';
import FormRow from 'components/FormRow';
import LoadingCircle from 'components/LoadingCircle';
import Textbox from 'components/Textbox';

class NewMessageForm extends React.Component {
    static propTypes = {
        error: PropTypes.object.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        isSending: PropTypes.bool.isRequired,
        message: PropTypes.string.isRequired,
        setMessage: PropTypes.func.isRequired
    };

    _handleChange(name, value) {
        console.log(name, value);
        this.props.setMessage(value);
    }

    _handleSubmit(isValid) {
        if(isValid === true) {
            this.props.handleSubmit()
                .then(() => {
                    this.props.$fieldEvent('reset');
                });
        }
    }

    render() {
        let { error, isSending, message, $field, $validation } = this.props;

        return (
            <Form className="new-message-form">
                <FormRow>
                    <Textbox
                        id="txtMessage"
                        label="Message"
                        name="message"
                        required
                        type="textarea"
                        validation={$validation.message}
                        value={message || ''}
                        {...$field('message', (event) => handleTextChange(this._handleChange.bind(this), event))}
                    />
                </FormRow>

                {Object.keys(error).length > 0 ? (
                    <FormRow className="error-message">
                        <FormValidationMessage>
                            {error.friendlyMessage || error.message}
                        </FormValidationMessage>
                    </FormRow>
                ) : null}

                <FormRow className="button-wrapper">
                    <Button className="a-button--primary"
                            disabled={isSending === true}
                            onClick={(event) => {
                                event.preventDefault();
                                this.props.$submit(this._handleSubmit.bind(this, true), this._handleSubmit.bind(this, false));
                            }}
                            type="submit">
                        Send
                        {isSending === true ? <LoadingCircle innerColor="#ffffff" outerColor="#ffffff" /> : null}
                    </Button>
                </FormRow>
            </Form>
        );
    }
}

function newMessageFormValidationConfig(props) {
    const { message } = props;

    return {
        fields: ['message'],
        validations: {
            message: [
                [isRequired, message]
            ]
        }
    }
}

export default NewMessageForm = validated(newMessageFormValidationConfig)(NewMessageForm);



// WEBPACK FOOTER //
// ./src/containers/Messaging/NewMessageForm.js